// extracted by mini-css-extract-plugin
module.exports = {"card-sms":"SmsBlock_card-sms_2D9PD","warning":"SmsBlock_warning_2QFBK","danger":"SmsBlock_danger_2nFnp"};